const freqAndUrgency= [

    {
    label:"Problem:",
    controlType:"radio button",
    options:["Frequency", "Urgency", "Frequency & urgency" ]
    },

    {
    label:"Occurs:",
    controlType:"radio button",
    options:["Every Day", "Most days", "Weekly", "Every couple of weeks", "Monthly", "Occasionally"]
    },
    
    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days","Weeks","Months","Years"]
    }
    
]

export default freqAndUrgency